// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mini-information[data-v-7b0fe4e2] {\n  height: 100%;\n}\n.mini-information .title-cell[data-v-7b0fe4e2] {\n  display: flex;\n  align-items: center;\n  gap: 0.12rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
